import React, { useContext } from 'react';
import { Button, ButtonType } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';

import cx from 'classnames';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';

const ParentEmailComplete = ({ handleMoveNext }) => {
  const context = useContext(AppContext);

  const moveNext = () => {
    handleMoveNext();
  };

  const subTitlePanel = (
    <p className="help-text">
      동의가 완료되었습니다.
      <br />
      아래를 눌러 가입자 본인의 정보 입력을 진행해 주세요.
    </p>
  );

  return (
    <GridPanel
      title={'법정대리인 동의'}
      subTitle={subTitlePanel}
      button={<Button buttonType={ButtonType.submit} onClick={moveNext} />}
    />
  );
};

export default ParentEmailComplete;
